const variantDataContainer = document.querySelector(
  "[data-variant-hide-kit-json]"
);

const textContent = variantDataContainer.innerText || [];
const variantData = JSON.parse(textContent);
const kitHiddenForVariants = variantData
  .filter((v) => v.hide_wine_kit)
  .map((v) => v.variant_id);

function checkDisabledWineKit(variant) {
  const defaultVariantId = document.querySelector('[data-default-variant]').dataset.defaultVariant;
  
  let currentVariant = variant?.id.toString() || defaultVariantId;

  if (kitHiddenForVariants.includes(currentVariant)) {
    document.querySelector('input[name="wine-kit"][value="false"]').click();
    document.querySelectorAll('input[name="wine-kit"]').forEach((el) => {
      el.setAttribute("disabled", true);
      el.closest('.wine-kit-form').style.pointerEvents = "none";
    });
    document.querySelector('[data-wine-kit-unavailable-message]').classList.remove('hide');
  } else {
    document.querySelectorAll('input[name="wine-kit"]').forEach((el) => {
      el.removeAttribute("disabled");
      el.closest('.wine-kit-form').style.pointerEvents = "auto";
    });
    document.querySelector('[data-wine-kit-unavailable-message]').classList.add('hide');
  }
}

document.addEventListener("DOMContentLoaded", () => checkDisabledWineKit(null));

document.addEventListener("variant:change", function (evt) {
  checkDisabledWineKit(evt.detail.variant);
});
